import { Button, Col, Flex, Form, Row, Space, Upload } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormInputNumber, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import * as service from "../services/adminApi";
import { getBase64 } from "components/elements/upload/Upload.utils";
import { dataURLtoFile } from "utils/helper";
import styles from "../styles/AdminCompany.module.css";
import { LoadingOutlined, MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const AdminDetailForm = ({
    setIsEdit = () => { },
    companyInfo = [],
    employeeOptions = [],
    onUpdateAdminCompanyInfo = () => { }
}) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState(
        companyInfo.logo ? `data:image/jpeg;base64,${companyInfo.logo}` : null
    );

    const uploadButton = (
        <button
            style={{
                border: 0,
                background: "none",
            }}
            type="button"
        >
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div
                style={{
                    marginTop: 8,
                }}
            >
                {t("common.upload")}
            </div>
        </button>
    );

    const beforeUpload = (file) => {
        return false;
    };

    const calculatePeriod = (startDate) => {
        if (!startDate) return "";

        const start = dayjs(startDate);
        if (!start.isValid()) return "";

        const end = dayjs();
        const diffDays = end.diff(start, "day");

        const years = Math.floor(diffDays / 365);
        const months = Math.floor((diffDays % 365) / 30);
        const days = diffDays - (years * 365 + months * 30);

        if (years > 0) {
            return `${years} ${t("unit.years")} ${months > 0 ? months + t("unit.months") : ""}${days > 0 ? days + t("unit.days") : ""}`;
        } else if (months > 0) {
            return `${months} ${t("unit.months")} ${days > 0 ? days + t("unit.days") : ""}`;
        } else {
            return `${days} ${t("unit.days")}`;
        }
    };


    return (
        <FormAntd
            form={form}
            initialValues={{
                ...companyInfo,
                adminListId: companyInfo?.adminList?.map((admin) => admin?.id) || [],
                numberOfEmployee: companyInfo?.countEmployee,
                companyLogo: companyInfo.logo ? dataURLtoFile(`data:image/jpeg;base64,${companyInfo.logo}`) : null,
                startDate: companyInfo?.startDateInFlowHr ? dayjs(companyInfo.startDateInFlowHr) : null,
                totalPeriod: calculatePeriod(companyInfo?.startDateInFlowHr),
            }}
            onFinish={(values) => onUpdateAdminCompanyInfo(values, () => setIsEdit(false))}        >

            <FormItem
                shouldUpdate={(prev, curv) => {
                    return false
                }}
            >
                {({ getFieldValue, setFieldValue, resetFields }) => {

                    const onAvatarChange = async (info) => {
                        setLoading(true);
                        const compressImg = await service.compressedImage({
                            file: info.file
                        })
                        getBase64(compressImg.data, (url) => {
                            setLoading(false);
                            setFieldValue("companyLogo", dataURLtoFile(url));
                            setImageUrl(url);
                        });
                    };

                    const onClearAvatar = (e) => {
                        e.stopPropagation();
                        setFieldValue("companyLogo", null);
                        setLoading(false);
                        setImageUrl(null);
                    }

                    return (
                        <Flex vertical gap={24}>
                            <Row justify={"center"}>
                                <Form.Item name={"companyLogo"}>
                                    <Upload
                                        name="avatar"
                                        listType="picture-circle"
                                        className={styles.avatarUploader}
                                        showUploadList={false}
                                        beforeUpload={beforeUpload}
                                        onChange={onAvatarChange}
                                        action={null}
                                    >
                                        {imageUrl ? (
                                            <>
                                                <img
                                                    src={imageUrl}
                                                    alt="avatar"
                                                    className={styles.avatar}
                                                    style={{
                                                        width: "100%",
                                                    }}
                                                />
                                                <MinusCircleOutlined
                                                    className={styles.avatarMinusIcon}
                                                    onClick={onClearAvatar}
                                                />
                                            </>
                                        ) : (
                                            uploadButton
                                        )}
                                    </Upload>
                                </Form.Item>
                            </Row>

                            <Row gutter={[16, 24]} style={{ marginLeft: "0px" }}>
                                <Col span={8}>
                                    <FormInput
                                        name="taxId"
                                        label={t("response_company.label.tax_id")}
                                        size="large"
                                        disabled
                                    />
                                </Col>
                                <Col span={8}>
                                    <FormInput
                                        name="companyName"
                                        label={t("company_profile.label.company_name_th")}
                                        size="large"
                                        disabled
                                    />
                                </Col>
                                <Col span={8}>
                                    <FormInput
                                        name="companyNameEn"
                                        label={t("company_profile.label.company_name_en")}
                                        size="large"
                                        disabled
                                    />
                                </Col>
                                <Col span={8} >
                                    <FormSelect
                                        name="adminListId"
                                        label={t("response_company.label.careTaker")}
                                        size="large"
                                        options={employeeOptions}
                                        allowClear
                                        mode="multiple"
                                    />
                                </Col>
                                <Col span={8}>
                                    <FormDatePicker
                                        name="startDate"
                                        label={t("response_company.label.start_date")}
                                        size="large"
                                    />
                                </Col>
                                <Col span={8}>
                                    <FormDatePicker
                                        name="expiredDate"
                                        label={t("response_company.label.exp_date")}
                                        size="large"
                                        disabled
                                    />
                                </Col>
                                <Col span={8}>
                                    <FormInput
                                        name="totalPeriod"
                                        label={t("response_company.label.total_use")}
                                        size="large"
                                        disabled
                                    />
                                </Col>
                                <Col span={8}>
                                    <FormInput
                                        name="remainingTime"
                                        label={t("response_company.label.remaining")}
                                        size="large"
                                        disabled
                                    />
                                </Col>
                                <Col span={8}>
                                    <FormInput
                                        name="numberOfEmployee"
                                        label={t("number-of-employees")}
                                        size="large"
                                        disabled
                                    />
                                </Col>
                            </Row>

                            <Row gutter={[16, 24]} justify="end">
                                <Space size={12}>
                                    <Button type="default"
                                        onClick={() => {
                                            resetFields();
                                            setIsEdit(false);
                                        }}
                                        size="large"
                                        style={{ borderRadius: "8px" }}>
                                        {t("common.cancel").toUpperCase()}
                                    </Button>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        // disabled={isLoading}
                                        style={{ borderRadius: "8px", backgroundColor: "var(--button-color)" }}
                                        size="large"
                                    >
                                        {t("common.save").toUpperCase()}
                                    </Button>
                                </Space>
                            </Row>
                        </Flex>
                    )
                }}
            </FormItem>
        </FormAntd>
    )
}

export default AdminDetailForm;